import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { interpolateDoubleBracesString } from '@frontend/sports/common/core/utils/string';

@Component({
    selector: 'bs-linear-bet-builder-header',
    template: '{{ title }}',
    styleUrls: ['./linear-bet-builder-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearBetBuilderHeaderComponent {
    @Input() betCount: number;

    private readonly titleTemplate: string;

    constructor(sitecore: Sitecore) {
        this.titleTemplate = sitecore.betslip.linear.BabTitle;
    }

    get title(): string {
        return interpolateDoubleBracesString(this.titleTemplate, { betCount: this.betCount });
    }
}
